import { ReactNode } from 'react';
import { IFilterClickContext, IFilterSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';

interface IFilterSetConfig {
  key: string,
  items: {
    id: string,
    abbreviation: string,
    queryName?: string,
    disabled?: boolean,
    tooltip?: ReactNode,
    restrictedTooltip?: ReactNode,
    onClick?: (context: IFilterClickContext) => void,
  }[],
  isVisible?: boolean,
  allowEmpty?: boolean,
  defaultActive?: string[],
}

export const transformToFilterSets = (
  filterConfigs: IFilterSetConfig[],
  query: Record<string, string | string[] | undefined>,
): IFilterSet[] => {
  return filterConfigs.map(({ key, items, isVisible, allowEmpty, defaultActive }) => {
    const queryAbbreviations = query[key] ? String(query[key]).split(',') : [];
    const activeAbbreviations = queryAbbreviations.length > 0 ? queryAbbreviations : defaultActive ?? [];

    return {
      key,
      items: items.map((item) => {
        const queryName = item.queryName ?? item.abbreviation;
        return {
          ...item,
          isActive: activeAbbreviations.includes(queryName),
        };
      }),
      isVisible,
      allowEmpty,
      defaultActive,
    };
  });
};
